import { render, staticRenderFns } from "./DialogCheck.vue?vue&type=template&id=a2dab95e&scoped=true&"
import script from "./DialogCheck.vue?vue&type=script&lang=js&"
export * from "./DialogCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2dab95e",
  null
  
)

export default component.exports